module.exports = __webpack_public_path__ + "static/media/arrow-rightt.5dced429.svg";